import { IconButton, Popover, Tooltip } from "@mui/material";
import { useState, useRef } from "react";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { useTranslation } from "react-i18next";

import Components from "./Components";

const DashBoardsEditAndReorderComponents = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const [popoverPosition, setPopoverPosition] = useState<"bottom" | "top">(
    "bottom"
  );

  const [space, setSpace] = useState<number | null>(null);

  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);

    const rect = event.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < 300 && spaceAbove > spaceBelow) {
      setSpace(spaceBelow);
      setPopoverPosition("top");
    } else {
      setSpace(null);
      setPopoverPosition("bottom");
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? "dashboard-menu-popover" : undefined;

  return (
    <>
      <Tooltip title={t("components.panel.select_tooltip")}>
        <IconButton
          size="small"
          aria-describedby={id}
          onClick={handleClick}
          ref={buttonRef}
        >
          <FormatListBulletedIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: popoverPosition === "top" ? "right" : "left",
        }}
        transformOrigin={
          popoverPosition === "top"
            ? {
                vertical: "bottom",
                horizontal: "left",
              }
            : undefined
        }
      >
        <Components spaceBelow={space} />
      </Popover>
    </>
  );
};

export default DashBoardsEditAndReorderComponents;
